<template>
    <el-dialog
        :title="title"
        :visible.sync="appointmentDialogVisible"
        width="90%"
        class="appointmentDialog"
        :before-close="closeDialogOnly"
        :close-on-click-modal="false"
    >
        <div class="carryBox" v-loading="loading">
            <div class="concent-right">
                <div class="serach">
                    <el-input type="text" class="orderNo" v-model.trim="orderNo" placeholder="订单号" clearable />
                    <el-button type="primary" @click="searchChange">查 询</el-button>
                </div>
                <el-table
                    class="appointmentTable"
                    ref="appointmentTable"
                    :data="newAppointmentData"
                    tooltip-effect="dark"
                    border
                    :row-class-name="tableRowClassName"
                    :before-close="closeDialogOnly"
                    @row-click="rowClick"
                    @selection-change="selectionChange"
                    @current-change="handleCurrentChange"
                    highlight-current-row
                    height="325px"
                >
                    <el-table-column type="selection" width="44" fixed></el-table-column>
                    <el-table-column
                        prop="orderNo"
                        label="订单号"
                        width="154"
                        show-overflow-tooltip
                    ></el-table-column>
                      <el-table-column label="品牌" width="200" show-overflow-tooltip>
                        <template slot-scope="scope">{{scope.row.brand ||''}}</template>
                    </el-table-column>
                     <el-table-column label="产品品类" width="240" show-overflow-tooltip>
                        <template slot-scope="scope">{{scope.row.itemClassName||''}}</template>
                    </el-table-column>
                    <el-table-column label="产品类型" width="280" show-overflow-tooltip>
                        <template slot-scope="scope">{{scope.row.itemName||''}}</template>
                    </el-table-column>
                    <el-table-column label="实际送装类型" width="100">
                        <template slot-scope="scope">
                            {{scope.row.factInstallTypeName}}
                        </template>
                    </el-table-column>
                      <el-table-column label="预约配送时间" width="140">
                        <template slot-scope="scope">
                            {{scope.row.networkAppointmentStart}}
                        </template>
                    </el-table-column>
                     <el-table-column label="预约安装时间" width="140">
                        <template slot-scope="scope">
                            {{scope.row.installStartTime}}
                        </template>
                    </el-table-column>
                    <el-table-column label="期望送装类型" width="96" show-overflow-tooltip>
                        <template slot-scope="scope">{{scope.row.expectInstallTypeName}}</template>
                    </el-table-column>
                    <el-table-column label="用户要求送达时间" width="140" show-overflow-tooltip>
                        <template slot-scope="scope">{{scope.row.expectArriveTime||''}}</template>
                    </el-table-column>
                    <el-table-column label="期望配送时间" width="186" show-overflow-tooltip>
                        <template slot-scope="scope">{{scope.row.expectDeliveryTime||''}}</template>
                    </el-table-column>
                    <el-table-column label="期望安装时间" width="140" show-overflow-tooltip>
                        <template slot-scope="scope">{{scope.row.expectInstallTime||''}}</template>
                    </el-table-column>
                    <el-table-column label="备注" show-overflow-tooltip width="250">
                        <template slot-scope="scope">
                            {{scope.row.networkAppointmentRemark}}
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="concent-left">
                <div class="base-info">
                    <el-form label-position="right" label-width="100px" :model="currentRowData">
                            <template v-if="currentRowData.orderType && currentRowData.orderType === 'RI'">
                                <el-form-item label="用 户："><span>{{currentRowData.netTaskAddress.senderName||currentRowData.senderName}}</span></el-form-item>
                                <el-form-item label="电 话："><span>{{currentRowData.netTaskAddress.senderMobile||currentRowData.senderMobile}}</span></el-form-item>
                                <el-form-item label="地 址："><span>{{currentRowData.netTaskAddresssenderProvinceName||'-'}} /
                            {{currentRowData.netTaskAddress.senderCityName||'-'}} /
                            {{currentRowData.netTaskAddress.senderDistrictName||'-'}} /
                            {{currentRowData.netTaskAddress.senderTownName||'-'}}
                            {{currentRowData.netTaskAddress.senderDetailAddr}}</span></el-form-item>
                            </template>
                            <template v-else-if="currentRowData.orderType && currentRowData.orderType !== 'RI'">
                                <el-form-item label="用 户："><span>{{currentRowData.netTaskAddress.receiverName||currentRowData.receiverName}}</span></el-form-item>
                                <el-form-item label="电 话："><span>{{currentRowData.netTaskAddress.receiverMobile||currentRowData.receiverMobile}}</span></el-form-item>
                                <el-form-item label="地 址："><span>{{currentRowData.netTaskAddress.receiverProvinceName||'-'}} /
                            {{currentRowData.netTaskAddress.receiverCityName||'-'}} /
                            {{currentRowData.netTaskAddress.receiverDistrictName||'-'}} /
                            {{currentRowData.netTaskAddress.receiverTownName||'-'}}
                            {{currentRowData.netTaskAddress.receiverDetailAddr}}</span></el-form-item>
                            </template>
                    </el-form>
                </div>
                <div class="appoint-edit-info">
                    <appoint-edit-cont ref="appointEditInfo" :rowData="currentRowData"
                        @saveResult="saveResult"></appoint-edit-cont>
                </div>
            </div>
        </div>
        <div slot="footer" class="dialog-footer">
            <el-button @click="closeDialogOnly">取 消</el-button>
            <el-button type="primary" @click="saveAppointment">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
import dayjs from 'dayjs';
import api from '../../../../api/netTaskManage2c.js';
import AppointEditCont from './AppointEditCont';
import { dictWithUrl } from '@/components/lots/api.js';

export default {
    name: 'appointMentDialog',
    components: { AppointEditCont },
    data() {
        return {
            rowData: {},
            loading: false,
            title: '预约',
            currentDate: dayjs().format('YYYY-MM-DD'),
            currentTime: '',
            appointmentDialogVisible: false,
            tempData: [],
            appointmentData: [],
            newAppointmentData: [],
            currentRowData: {},
            selectedData: [],
            installTypeOpt: [],
            orderNo: ''
        };
    },
    methods: {
        tableRowClassName({ row }) {
            if (
                this.selectedData &&
                this.selectedData
                    .map((item) => item.orderNo)
                    .includes(row.orderNo)
            ) {
                return 'highlight-row';
            }
        },
        async show(rowData) {
            if ((rowData.orderType === 'RI' && !rowData.senderMobile) || (rowData.orderType !== 'RI' && !rowData.receiverMobile)) {
                this.$message.warning('该订单没有对应联系人电话号码');
                return this.closeDialogOnly();
            };
            this.appointmentDialogVisible = true;
            this.loading = true;
            await this.getOptionList();
            const params = rowData.orderType === 'RI'
                ? { senderMobile: rowData.senderMobile, networkCode: rowData.networkCode }
                : { receiverMobile: rowData.receiverMobile, networkCode: rowData.networkCode };
            // 预约信息
            let currentInx;
            await api.appointmentInfo(params).then((res) => {
                if (res && res.code === '0' && res.data.length) {
                    res.data.map((item, idx) => {
                        if (item) {
                            if (item.orderNo === rowData.orderNo) {
                                currentInx = idx.toString();
                            }
                            this.formatData(item);
                        }
                    });
                    // 当前订单推到第一行并勾选
                    if (currentInx) {
                        res.data.unshift(res.data.splice(currentInx, 1)[0]);
                    };
                    this.appointmentData = res.data;
                    this.newAppointmentData = this.appointmentData;
                }
            }).catch(() => {});
            this.$nextTick(() => {
                if (currentInx) {
                    this.$refs.appointmentTable.toggleRowSelection(this.newAppointmentData[0]);
                    this.$refs.appointmentTable.setCurrentRow(this.newAppointmentData[0]);
                    this.$refs.appointmentTable.doLayout();
                    this.loading = false;
                };
            });
        },
        formatData(item) {
            // 默认设置送装类型;
            if (item.orderType === 'DP') {
                item.factInstallTypeName = item.factInstallType ? '上门取件' : '';
            } else {
                item.factInstallTypeName = this.installType[item.factInstallType] || '';
            }
            item.expectInstallType && !item.expectInstallTypeName && (item.expectInstallTypeName = this.installType[item.expectInstallType]);
            // 日期改格式
            if (
                item.expectArriveStartTime &&
                    item.expectArriveEndTime
            ) {
                item.expectDeliveryTime =
                    item.expectArriveStartTime + '-' +
                    item.expectArriveEndTime.split(' ')[1];
            } else if (item.expectArriveStartTime &&
                    !item.expectArriveEndTime) {
                item.expectDeliveryTime =
                    item.expectArriveStartTime.split(' ')[0] + ' 00:00:00-23:59:59';
            }
            if (
                item.expectInstallStartTime &&
                    item.expectInstallEndTime
            ) {
                item.expectInstallTime =
                    item.expectInstallStartTime + '-' +
                    item.expectInstallEndTime.split(' ')[1];
            } else if (item.expectInstallStartTime &&
                    !item.expectInstallEndTime) {
                item.expectInstallTime =
                    item.expectInstallStartTime.split(' ')[0] + ' 00:00:00-23:59:59';
            }
            if (item.expectArriveStartTime) {
                item.expectArriveTime = item.expectArriveStartTime + (item.expectArriveEndTime ? ' - ' +
                    item.expectArriveEndTime.split(' ')[1] : '');
            }
            item.appointToday = false;
            item.installToday = false;
        },
        async getOptionList() {
            // 获取配送方式数据字典
            const dictData = await dictWithUrl('INSTALL_TYPE');
            this.installType = dictData.data.INSTALL_TYPE || false;
            if (!this.installType) {
                this.$message.warning('获取数据字典失败，请刷新页面重试');
                this.closeDialogOnly();
            } else {
                this.installTypeOpt = Object.entries(this.installType).map((item) => {
                    return {
                        value: item[0],
                        label: item[1]
                    };
                });
                this.installTypeOpt = this.installTypeOpt.reverse();
            }
        },
        rowClick(row) {
            this.$refs.appointmentTable.toggleRowSelection(row, true);
        },
        selectionChange(data) {
            this.selectedData = data;
        },
        handleCurrentChange(currentRow, oldCurrentRow) {
            this.currentRowData = currentRow;
        },
        async saveAppointment() {
            if (!this.selectedData.length) {
                return this.$message.warning('请先选择需预约内容');
            }
            this.loading = true;
            this.$refs.appointEditInfo.checkSave(this.selectedData);
        },
        saveResult(res) {
            this.loading = false;
            if (res) {
                this.$message.success('预约成功');
                this.$emit('closeDialog', 'appointmentDialog', true);
            }
        },
        closeDialogOnly() {
            this.$emit('closeDialog', 'appointmentDialog', false);
        },
        closeAndRefresh() {
            this.$emit('closeDialog', 'appointmentDialog', true);
        },
        searchChange() {
            if (this.orderNo) {
                this.newAppointmentData = this.appointmentData.filter(item => {
                    return item.orderNo === this.orderNo;
                });
                if (!this.newAppointmentData.length) {
                    this.newAppointmentData = this.appointmentData;
                    return this.$message.warning('查询不到该订单号！');
                }
            } else {
                this.newAppointmentData = this.appointmentData;
            }
            this.$nextTick(() => {
                this.$refs.appointmentTable.toggleRowSelection(this.newAppointmentData[0]);
                this.$refs.appointmentTable.setCurrentRow(this.newAppointmentData[0]);
                this.$refs.appointmentTable.doLayout();
            });
        }
    }
};
</script>

<style lang="less">
.appointmentDialog {
     min-width: 800px;
     .orderNo{
         margin-right: 10px;
         width: 200px;
     }
    .carryBox{
        display: flex;
        .concent-left{
            width: 350px;
            border-left: 1px solid #e6e6e6;
            margin-left: 10px;
            padding-left: 10px;
        }
        .concent-right{
            flex: 1;
            overflow: auto;
        }
        .serach{
            margin: 5px 0px;
        }
    }
    .base-info {
            border-bottom: 1px solid #e6e6e6;
            margin-bottom: 10px;
            padding-bottom: 5px;
            .el-form-item {
                margin-bottom: 0px;
            }
            .el-form-item__label,.el-form-item__content{
                line-height: 25px;
            }
        }
    .appointmentTable {
        .el-form-item__content {
            line-height: 0px;
        }
        .el-table__body tr.current-row > td {
        background-color: #b2deec;
        color: #c56183;
        }
        .cell {
            height: 28px;
            line-height: 28px;
            font-size: 10px;
            .el-date-editor.el-input,
            .el-date-editor.el-input__inner {
                width: 100%;
            }
        }
    }
    .el-table__body tr.highlight-row {
        background: #e6f8f9;
     }
     .el-dialog__body{
         padding-top: 5px;
     }
    .el-dialog__footer{
        margin-bottom: 5px;
        padding: 0px 20px 10px;
    }
}
</style>